import { render, staticRenderFns } from "./iar-delivery.vue?vue&type=template&id=4dade102&"
import script from "./iar-delivery.vue?vue&type=script&lang=js&"
export * from "./iar-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports